module.exports = __webpack_public_path__ + "static/media/lp4.6d84be81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lp4.jpg
// module id = 681
// module chunks = 31